<template>
    <Layout>
    <PageHeader title="Wizard" :items="[]" />
        <div class="row">
            <div class="col-xl-6">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Tab Wizard</h4>
                        <form-wizard shape="tab" color="#556ee6">
                            <!-- STEP 1 -->
                            <tab-content icon="mdi mdi-numeric-1-box">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group row mb-3">
                                            <label class="col-md-3 col-form-label" for="name">User name</label>
                                            <div class="col-md-9">
                                                <input id="name" type="text" class="form-control" value="Themesbrand"/>
                                            </div>
                                        </div>
                                        <div class="form-group row mb-3">
                                            <label class="col-md-3 col-form-label" for="pwd">Password</label>
                                            <div class="col-md-9">
                                                <input id="pwd" type="password" name="pwd" class="form-control" value="123456789"/>
                                            </div>
                                        </div>
                                        <div class="form-group row mb-3">
                                            <label class="col-md-3 col-form-label" for="confirmpwd">Re Password</label>
                                            <div class="col-md-9">
                                                <input id="confirmpwd" type="password" class="form-control" value="123456789"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>

                            <!-- STEP 2 -->
                            <tab-content icon="mdi mdi-numeric-2-box">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group row mb-3">
                                            <label class="col-md-3 col-form-label" for="name">User name</label>
                                            <div class="col-md-9">
                                                <input id="name" type="text" class="form-control" value="Themesbrand"/>
                                            </div>
                                        </div>
                                        <div class="form-group row mb-3">
                                            <label class="col-md-3 col-form-label" for="pwd">Password</label>
                                            <div class="col-md-9">
                                                <input id="pwd" type="password" name="pwd" class="form-control" value="123456789"/>
                                            </div>
                                        </div>
                                        <div class="form-group row mb-3">
                                            <label class="col-md-3 col-form-label" for="confirmpwd">Re Password</label>
                                            <div class="col-md-9">
                                                <input id="confirmpwd" type="password" class="form-control" value="123456789"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>

                            <!-- STEP 3 -->
                            <tab-content icon="mdi mdi-numeric-2-box">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group row mb-3">
                                            <label class="col-md-3 col-form-label" for="name">User name</label>
                                            <div class="col-md-9">
                                                <input id="name" type="text" class="form-control" value="Themesbrand"/>
                                            </div>
                                        </div>
                                        <div class="form-group row mb-3">
                                            <label class="col-md-3 col-form-label" for="pwd">Password</label>
                                            <div class="col-md-9">
                                                <input id="pwd" type="password" name="pwd" class="form-control" value="123456789"/>
                                            </div>
                                        </div>
                                        <div class="form-group row mb-3">
                                            <label class="col-md-3 col-form-label" for="confirmpwd">Re Password</label>
                                            <div class="col-md-9">
                                                <input id="confirmpwd" type="password" class="form-control" value="123456789"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>


                            <!-- STEP 4 -->
                            <tab-content icon="mdi mdi-numeric-3-box">
                                <div class="row">
                                    <div class="col-12">
                                        <b-alert show>Finished </b-alert>
                                    </div>
                                </div>
                            </tab-content>
                        </form-wizard>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
export default {
    data:() => ({}),
    components:{
        Layout, PageHeader, FormWizard, TabContent
    },
    computed:{},
    methods:{},
    mounted(){},
}
</script>

<style>

</style>